// extracted by mini-css-extract-plugin
export default {"hamburger":"DropDownNavMenu_hamburger__9WavX","line":"DropDownNavMenu_line__ZTpb8","menu":"DropDownNavMenu_menu__5DxfQ","active":"DropDownNavMenu_active__2sig2"};